import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/MortgageOverpaymentCalculator.jpg";
import MortgageOverpaymentCalculator from "../../frontend/components/calculators/OverpaymentCalculator";

const MortgageOverpaymentCalculatorsPage = () => {
  return (
    <div>
      <Hero
        title="Overpayment"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <MortgageOverpaymentCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageOverpaymentCalculatorsPage;
